// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller
/* eslint-disable */

import { application } from "../application"
import "../fudgeball"

import BlendNavigationController from './blend/navigation_controller.js'
application.register('blend--navigation', BlendNavigationController)

import CarouselController from './carousel_controller.js'
application.register('carousel', CarouselController)

import CountdownController from './countdown_controller.js'
application.register('countdown', CountdownController)

import FooterController from './footer_controller.js'
application.register('footer', FooterController)

import FullPhotoEditorController from './full_photo_editor_controller.js'
application.register('full-photo-editor', FullPhotoEditorController)

import MacyController from './macy_controller.js'
application.register('macy', MacyController)

import PhotoEditorController from './photo_editor_controller.js'
application.register('photo-editor', PhotoEditorController)

import PlacesController from './places_controller.js'
application.register('places', PlacesController)

import ResizerController from './resizer_controller.js'
application.register('resizer', ResizerController)

import RoutesController from './routes_controller.js'
application.register('routes', RoutesController)

import SliderController from './slider_controller.js'
application.register('slider', SliderController)

import SlideshowController from './slideshow_controller.js'
application.register('slideshow', SlideshowController)

import TextEditorController from './text_editor_controller.js'
application.register('text-editor', TextEditorController)

import YoutubeMusicController from './youtube_music_controller.js'
application.register('youtube-music', YoutubeMusicController)
